import { FDFTUXType, FDIntentTypes, FTUXType } from '../../../types/fd-ftux.types'
import { bondsDebtMFsFTUX } from './bondsDebtMFsFTUX'
import { equityFTUX } from './equityFTUX'
import { traditionalFDsFTUX } from './traditionalFDsFTUX'

const lastScreen: FTUXType = [
  [
    {
      type: 'TEXT',
      text: `Power FD fits your needs. `,
      className: 'text-[#D1ECFF] text-[18px] font-[400] leading-[140%] pb-2'
    },
    {
      type: 'TEXT',
      text: `Ready to book <br /> your first FD?`,
      className: 'text-[32px] font-[500] leading-[120%] pb-8'
    },
    {
      type: 'RADIO_BOX',
      title: FDIntentTypes.INVEST_NOW,
      text: 'Show me the best FD plans.',
      className: 'pb-3 w-full px-5'
    },
    {
      type: 'RADIO_BOX',
      title: FDIntentTypes.CALLBACK,
      text: 'Our team will reach back to you in 24 hrs.',
      className: 'pb-3 w-full px-5'
    },
    {
      type: 'RADIO_BOX',
      title: FDIntentTypes.INVEST_LATER,
      text: 'I have the intent but will invest later.',
      className: 'w-full px-5'
    }
  ]
]

export const fdFtuxConfig = {
  [FDFTUXType.TRADITIONAL_FDs]: [...traditionalFDsFTUX, ...lastScreen],
  [FDFTUXType.BONDS_DEBT_MFs]: [...bondsDebtMFsFTUX, ...lastScreen],
  [FDFTUXType.EQUITY]: [...equityFTUX, ...lastScreen]
}

export const getInvestNowCTA = (intent: string) => {
  return {
    type: 'CTA',
    ctaType: 'DEFAULT',
    method: 'POST',
    navigationStyle: 'PUSH_REPLACEMENT',
    url: '/v1/power-fd/plans-wrapper',
    isNavigationDeferred: false,
    requestPayload: {
      postBackParams: {
        uiType: 'ALL_PLANS_VIEW',
        inputData: { usersIntentSummary: intent }
      }
    }
  }
}

export const getFDDashboardCTA = (intent: string) => {
  return {
    type: 'CTA',
    ctaType: 'DEFAULT',
    method: 'POST',
    navigationStyle: 'PUSH_REPLACEMENT',
    url: '/v2/power-fd/dashboard-redirection',
    isNavigationDeferred: false,
    requestPayload: {
      inputData: { usersIntentSummary: intent }
    }
  }
}
